/*Package importing*/
import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import $ from 'jquery';

/*Components*/
import SelectBox from '../../components/formComponents/selectBox';
import APILoader from '../../components/other/api-loader';
import NoDataFound from '../../components/other/nothing';
import AddProduct from './addProduct';
import EditProduct from './editProduct';
import Toast from '../../components/toast/toast';

/*Assets*/

/*Services*/
import devconfig from '../../config/config.js';
import APIPost from '../../services/apiCall/post';



class ManageProducts extends Component {
  constructor(props){
    super(props);
    this.state = {
      apiLoading: false,
      pageNumActive: true,
      pageNumLoader: false,
      pageNum: 1,
      addProduct: false,
      editProduct: false,
      data:[],
      error: "",
      toast: null,
      toastType: "",
      updateProduct: {}
    }
  }

  componentDidMount() {
    this.getProducts();
  }

  getProducts(){
    this.setState({apiLoading: true, error: ""});
    let url = devconfig.vendor+ 'product/list';
    let data = JSON.stringify({ 
      "page_num" : 1

    });
    APIPost(url, data).then(function(response){
      if(response && response.status == "ok"){
        this.setState({data: response.data, apiLoading: false, error: ""})
      }
      else{
        this.setState({apiLoading: false, error: response.message});
      }
    }.bind(this))
  }

  deleteProducts(id){
    this.setState({apiLoading: true, error: ""});
    let url = devconfig.vendor+ 'product/delete';
    let data = JSON.stringify({ 
      "product_id" : id

    });
    APIPost(url, data).then(function(response){
      if(response.status == "ok"){
        this.setState({apiLoading: false, error: ""});
        this.getProducts();
        this.setState({toast: "Product deleted successfully", toastType:"success"})
        setTimeout( function() { this.setState({ toast: null}); }.bind(this), 4000);
      }
      else{
        this.setState({apiLoading: false, error: response.message});
      }
    }.bind(this))
  }

  updateProduct(product){
    this.setState({updateProduct: product, editProduct: true});
    console.log(product);
  }

  render() {

    return (
      <React.Fragment>
      <div>
          {
              !this.state.addProduct && !this.state.editProduct?
              <div className="e-main-content e-vendor-table">
            <h2 className="e-page-head">Manage Products / Services</h2>

            {
              this.state.apiLoading?
              <div className="row pt-5">
                <div className="col-lg-12 pt-5">
                  <APILoader/>
                </div>
              </div>
              :
              <>
              <div className="row">
              <div className="col-lg-12">
                <button className="e-s-btn e-new-ofer mt-2" onClick={()=>this.setState({addProduct: true})}>Add Product / Service</button>
              </div>
            </div>
            {
              this.state.data.length?
              <div className="w-100 px-0 pt-4 e-manage-table">
                <div class="table-responsive">
                    <table class="table">
                    <thead>
                        <tr>
                        <th scope="col">Product / Service Name</th>
                        <th scope="col">Department</th>
                        <th scope="col">Category</th>
                        <th scope="col">Subcategory</th>
                        <th scope="col">Price (In Rs.)</th>
                        <th scope="col">Actions</th>
                        </tr>
                    </thead>
                   {
                     this.state.data?
                     <tbody>
                     {
                         this.state.data.map(row =>(
                          <tr>
                          <td>{`${row.name}`}</td>
                          <td>{row.department}</td>
                          <td>{row.category}</td>
                          <td>{row.subcategory}</td>
                          <td>
                            {
                              row.variants && row.variants[0]
                              && row.variants[0].choices && row.variants[0].choices[0]
                              && row.variants[0].choices[0].mrp?
                              row.variants[0].choices[0].mrp
                              :
                              "--"
                            }
                          </td>
                          <td>
                              <div className="d-flex align-items-center">
                                  <Link to={`/product-detail?id=${row.product_id}`} className="text-decoration-none"><span className="px-2 e-link">View</span></Link>
                                  <span className="px-2 e-link" onClick={()=>this.updateProduct(row)}>Edit</span>
                                  <span className="px-2 e-link" onClick={()=>this.deleteProducts(row.product_id)}>Delete</span>
                              </div>
                          </td>
                      </tr>
                           ))
                     }
                 </tbody>
                 :
                 null
                   }
                    </table>
                </div>
            </div>
            :
            <div className="row">
              <div className="col-lg-12 pt-5">
                <NoDataFound head="Nothing Found" data="No Products Found"/>
              </div>
            </div>
            }
            </>
            }
          </div>
          : this.state.addProduct?
            <AddProduct cancel={()=>this.setState({addProduct: false})} success={() => {
              this.setState({toast: "Product added successfully", toastType:"success", addProduct: false})
              setTimeout( function() { this.setState({ toast: null}); }.bind(this), 4000);
              this.getProducts();}}/>

          : this.state.editProduct? 
            <EditProduct cancel={()=>{this.setState({editProduct: false, updateProduct:{}}); this.getProducts();}} success={() => {
            this.setState({toast: "Product updated successfully", toastType:"success", editProduct: false})
            setTimeout( function() { this.setState({ toast: null}); }.bind(this), 4000);
            this.getProducts();}} data={this.state.updateProduct} updateData={(temp)=>this.setState({updateProduct: temp})}/>
          :
          null
          }
      </div>
      {
        this.state.toast ?
          <Toast data={this.state.toast} type={this.state.toastType}/>
        :
          null
      }
      </React.Fragment>

    );
  }
}

export default ManageProducts;
